import { useCallback } from 'react'
import { Statsig } from 'src/sdk/statsig'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'

export const SHELF_EXPERIMENT_ID = 'experiment_vitrine_desktop_13022026'
export const DESCRIPTION_EXPERIMENT_ID = 'experiment_description_13022026'
export const REVIEWS_EXPERIMENT_ID = 'experiment_reviews_pdp_13022026'
export const PASSWORD_RECOVERY_EXPERIMENT_ID =
  'experiment_password-recovery_cart_02032026'

export const SIMPLIFIED_SHIPPING_EXPERIMENT_ID =
  'experiment_valores_frete_pdp_24032026'
export const KITLOOK_WIDGET_EXPERIMENT_ID =
  'experiment_kitlook_widget_pdp_11042016'

export const BUY_TOGETHER_EXPERIMENT_ID =
  'experiment_comprejunto_oportunista_10032016'

export const PROGRESSIVE_DISCOUNT_EXPERIMENT_ID =
  'experiment_desconto_progressivo_pdp_13032026'
export const PROGRESSIVE_DISCOUNT_CART_EXPERIMENT_ID =
  'experiment_promocionamentocarrinho_14092026'
export const SHARED_CART_EXPERIMENT_ID =
  'experiment_shared-cart_checkout_12052026'
export const SHIPPING_EXPERIMENT_ID = 'experiment_shipping_09062026'

export const PLP_COLLECTION_COMPONENTS_EXPERIMENT_ID =
  'experiment_drivers-comerciais_colecoes_08042026'

export const COLLECTION_2_0_EXPERIMENT_ID = 'experiment_colecao_2.0_01062026'

export const EMBED_HTML_PDP_EXPERIMENT_ID = 'experiment_embed_html_pdp_29052026'

export const PDP_BUY_BUTTON_EXPERIMENT_ID =
  'experiment_botao_comprar_pdp_07072026'
export const PDP_FIRST_FOLD_REVAMP_EXPERIMENT_ID =
  'experiment_primeira-dobra-precos_pdp_25062026'
export const ENABLE_GUEST_CHECKOUT_EXPERIMENT_ID = 'enable_guest_checkout'
export const PARCELAMENTO_FEEDBACK_MINICART_EXPERIMENT_ID =
  'experiment_parcelamento_feedback_minicart_15062026'
export const CASHBACK_FEEDBACK_EXPERIMENT_ID =
  'experiment_cashback_feedback_14092026'
export const SIMPLIFICAR_DESCONTOS_PDP_EXPERIMENT_ID =
  'experiment_simplificar_descontos_pdp_08072026'
export const NEWCART_HEADER_EXPERIMENT_ID = 'experiment_newcart_header_01082026'

export const FEM_MASC_TENIS_PDP_EXPERIMENT_ID =
  'experiment_fem_masc_tenis_pdp_08072026'
export const MINI_PDP_EXPERIMENT_ID = 'experiment_mini-pdp_25062026'
export const HIDE_VIDEO_PDP_EXPERIMENT_ID = 'experiment_video-pdp_14072026'
export const APROVEITE_E_LEVE_JUNTO_2_EXPERIMENT_ID =
  'experiment_aproveiteelevejunto2_14082026'
export const DY_ALTERNATIVE_SHELF_LAYOUT_EXPERIMENT_ID =
  'experiment_grid-vitrines_18082026'

export const UPGRADE_SHOPPING_MUSE_EXPERIMENT_ID =
  'experiment_upgradeshoppingmuse_19082026'
export const COUPON_WALLET_EXPERIMENT_ID =
  'experiment_carteiradecupomweb_08092026'

export const INSTALLMENTS_PRODUCT_CARD_EXPERIMENT_ID =
  'experiment_parcelamento_web_plp_01102026'
export const CART_PRODUCT_DETAILS_EXPERIMENT_ID =
  'experiment_cart-card-enrichment_08092026'

export const NEW_ORDER_SUMMARY_EXPERIMENT_ID = 'experiment_novoresumo_08092026'
export const MASS_REMOVAL_CART_EXPERIMENT_ID =
  'experiment_remocaodeitensweb_13102026'

function useAmplitudeExposure(experimentId: string) {
  const onExposure = useCallback(
    (value: boolean) => {
      try {
        dispatchAmplitudeEvent({
          eventName: '$exposure',
          eventData: {
            flag_key: experimentId,
            variant: `${value}`,
          },
        })
      } catch (error) {
        console.error(
          `Error dispatching exposure event for ${experimentId}:`,
          error
        )
      }
    },
    [experimentId]
  )

  Statsig.useStatsigExposure(experimentId, onExposure)
}

const StatsigExposure = () => {
  useAmplitudeExposure(REVIEWS_EXPERIMENT_ID)
  useAmplitudeExposure(SHELF_EXPERIMENT_ID)
  useAmplitudeExposure(DESCRIPTION_EXPERIMENT_ID)
  useAmplitudeExposure(PASSWORD_RECOVERY_EXPERIMENT_ID)
  useAmplitudeExposure(SIMPLIFIED_SHIPPING_EXPERIMENT_ID)
  useAmplitudeExposure(KITLOOK_WIDGET_EXPERIMENT_ID)
  useAmplitudeExposure(PLP_COLLECTION_COMPONENTS_EXPERIMENT_ID)
  useAmplitudeExposure(PROGRESSIVE_DISCOUNT_EXPERIMENT_ID)
  useAmplitudeExposure(SHARED_CART_EXPERIMENT_ID)
  useAmplitudeExposure(BUY_TOGETHER_EXPERIMENT_ID)
  useAmplitudeExposure(SHIPPING_EXPERIMENT_ID)
  useAmplitudeExposure(COLLECTION_2_0_EXPERIMENT_ID)
  useAmplitudeExposure(EMBED_HTML_PDP_EXPERIMENT_ID)
  useAmplitudeExposure(PDP_BUY_BUTTON_EXPERIMENT_ID)
  useAmplitudeExposure(MINI_PDP_EXPERIMENT_ID)
  useAmplitudeExposure(PDP_FIRST_FOLD_REVAMP_EXPERIMENT_ID)
  useAmplitudeExposure(SIMPLIFICAR_DESCONTOS_PDP_EXPERIMENT_ID)
  useAmplitudeExposure(NEWCART_HEADER_EXPERIMENT_ID)
  useAmplitudeExposure(FEM_MASC_TENIS_PDP_EXPERIMENT_ID)
  useAmplitudeExposure(PARCELAMENTO_FEEDBACK_MINICART_EXPERIMENT_ID)
  useAmplitudeExposure(CASHBACK_FEEDBACK_EXPERIMENT_ID)
  useAmplitudeExposure(HIDE_VIDEO_PDP_EXPERIMENT_ID)
  useAmplitudeExposure(APROVEITE_E_LEVE_JUNTO_2_EXPERIMENT_ID)
  useAmplitudeExposure(UPGRADE_SHOPPING_MUSE_EXPERIMENT_ID)
  useAmplitudeExposure(COUPON_WALLET_EXPERIMENT_ID)
  useAmplitudeExposure(DY_ALTERNATIVE_SHELF_LAYOUT_EXPERIMENT_ID)
  useAmplitudeExposure(INSTALLMENTS_PRODUCT_CARD_EXPERIMENT_ID)
  useAmplitudeExposure(CART_PRODUCT_DETAILS_EXPERIMENT_ID)
  useAmplitudeExposure(NEW_ORDER_SUMMARY_EXPERIMENT_ID)
  useAmplitudeExposure(MASS_REMOVAL_CART_EXPERIMENT_ID)

  return null
}

export default StatsigExposure
